import { useSearchResultLayout } from '../hooks/useSearchResultLayout';
import { useCssHandles } from '../../../../utils/functions';

type SearchResultLayoutContainerProps = { children: React.ReactNode };

const CSS_HANDLES = ['searchResultContainer'] as const;
const SearchResultLayoutContainer = ({ children }: SearchResultLayoutContainerProps) => {
	const { blockClass, componentId } = useSearchResultLayout();
	const { handles }: any = useCssHandles(`vtex-search-result-0-x`, CSS_HANDLES, blockClass);

	return (
		<div
			data-selection={componentId}
			className={`${handles.searchResultContainer} pt3-m pt5-l ph3 ph5-m ph2-xl mw9 center`}
		>
			{children}
		</div>
	);
};

export default SearchResultLayoutContainer;
